import React from 'react';
import PropTypes from 'prop-types';
import {
  Cushion,
  Panel,
  Rectangle,
  ScrollBox,
  Show,
  Typography,
  withTheme,
} from '@pitchero/react-ui';
import Icon from '../icon';
import Comments from '../comments/dynamic';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';
import { Trans } from '../../lib/i18n';
import panelTheme from '../../lib/club-theme/panel';
import useBreakpoint from '../../lib/use-breakpoint';

const PhotoComments = ({ closeComments, club, mediaType, mediaId, isOpen }) => {
  const { closeIconOptions } = panelTheme;
  const isTab = useBreakpoint('tab');
  const content = (
    <Rectangle
      fill="seashellgrey"
      component="div"
      style={{ height: '100%', boxSizing: 'border-box' }}
    >
      <ScrollBox yOnly>
        <Cushion all="medium">
          {!isTab && (
            <Cushion all={9}>
              <Rectangle
                fill={closeIconOptions.backgroundColor}
                radius="50%"
                style={{
                  position: 'absolute',
                  top: 12,
                  right: 12,
                  cursor: 'pointer',
                  lineHeight: 0,
                }}
              >
                <Icon
                  name="cross"
                  onClick={closeComments}
                  onKeyDown={closeComments}
                  color={closeIconOptions.color}
                />
              </Rectangle>
            </Cushion>
          )}
          <Typography preset="subtitle--large" color="black">
            <Trans i18nKey="common:comments_title">Comments</Trans>
          </Typography>
          <Cushion vertical="small" component="div">
            <Comments club={club} mediaType={mediaType} mediaId={mediaId} />
          </Cushion>
        </Cushion>
      </ScrollBox>
    </Rectangle>
  );

  return (
    <>
      {isOpen && (
        <Show minWidth="tab" component="div" style={{ height: '100%' }}>
          {!isTab && content}
        </Show>
      )}

      <Panel isOpen={isTab && isOpen} onClose={closeComments}>
        {isTab && content}
      </Panel>
    </>
  );
};

PhotoComments.propTypes = {
  closeComments: PropTypes.func.isRequired,
  club: CLUB_PROP_TYPES.isRequired,
  mediaId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  mediaType: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default withTheme(PhotoComments);
